import * as customPropTypesSource from './custom-prop-types';

export const CustomPropTypes = { ...customPropTypesSource };
export { default as validation } from './input-validation.js';
